function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["content", "onAction"],
  _excluded2 = ["title", "actions"];
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useRef, useState, useReducer, useCallback, useEffect, useMemo } from 'react';
import { classNames } from '../../../../utilities/css.js';
import styles from './Actions.scss.js';
import { getVisibleAndHiddenActionsIndices } from './utilities.js';
import { MenuGroup } from '../MenuGroup/MenuGroup.js';
import { ActionsMeasurer } from './components/ActionsMeasurer/ActionsMeasurer.js';
import { useI18n } from '../../../../utilities/i18n/hooks.js';
import { SecondaryAction } from '../SecondaryAction/SecondaryAction.js';
function Actions(_ref) {
  var actions = _ref.actions,
    groups = _ref.groups,
    onActionRollup = _ref.onActionRollup;
  var i18n = useI18n();
  var rollupActiveRef = useRef(null);
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    activeMenuGroup = _useState2[0],
    setActiveMenuGroup = _useState2[1];
  var _useReducer = useReducer(function (data, partialData) {
      return _objectSpread(_objectSpread({}, data), partialData);
    }, {
      disclosureWidth: 0,
      containerWidth: Infinity,
      actionsWidths: [],
      visibleActions: [],
      hiddenActions: [],
      visibleGroups: [],
      hiddenGroups: [],
      hasMeasured: false
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    setState = _useReducer2[1];
  var visibleActions = state.visibleActions,
    hiddenActions = state.hiddenActions,
    visibleGroups = state.visibleGroups,
    hiddenGroups = state.hiddenGroups,
    containerWidth = state.containerWidth,
    disclosureWidth = state.disclosureWidth,
    actionsWidths = state.actionsWidths,
    hasMeasured = state.hasMeasured;
  var defaultRollupGroup = {
    title: i18n.translate('Polaris.ActionMenu.Actions.moreActions'),
    actions: []
  };
  var handleMenuGroupToggle = useCallback(function (group) {
    return setActiveMenuGroup(activeMenuGroup ? undefined : group);
  }, [activeMenuGroup]);
  var handleMenuGroupClose = useCallback(function () {
    return setActiveMenuGroup(undefined);
  }, []);
  useEffect(function () {
    if (containerWidth === 0) {
      return;
    }
    var _getVisibleAndHiddenA = getVisibleAndHiddenActionsIndices(actions, groups, disclosureWidth, actionsWidths, containerWidth),
      visibleActions = _getVisibleAndHiddenA.visibleActions,
      visibleGroups = _getVisibleAndHiddenA.visibleGroups,
      hiddenActions = _getVisibleAndHiddenA.hiddenActions,
      hiddenGroups = _getVisibleAndHiddenA.hiddenGroups;
    setState({
      visibleActions: visibleActions,
      visibleGroups: visibleGroups,
      hiddenActions: hiddenActions,
      hiddenGroups: hiddenGroups,
      hasMeasured: containerWidth !== Infinity
    });
  }, [containerWidth, disclosureWidth, actions, groups, actionsWidths, setState]);
  var actionsOrDefault = useMemo(function () {
    return actions !== null && actions !== void 0 ? actions : [];
  }, [actions]);
  var groupsOrDefault = useMemo(function () {
    return groups !== null && groups !== void 0 ? groups : [];
  }, [groups]);
  var actionsMarkup = actionsOrDefault.filter(function (_, index) {
    if (!visibleActions.includes(index)) {
      return false;
    }
    return true;
  }).map(function (action) {
    var content = action.content,
      onAction = action.onAction,
      rest = _objectWithoutProperties(action, _excluded);
    return /*#__PURE__*/React.createElement(SecondaryAction, Object.assign({
      key: content,
      onClick: onAction
    }, rest), content);
  });
  var groupsToFilter = hiddenGroups.length > 0 || hiddenActions.length > 0 ? [].concat(_toConsumableArray(groupsOrDefault), [defaultRollupGroup]) : _toConsumableArray(groupsOrDefault);
  var filteredGroups = groupsToFilter.filter(function (group, index) {
    var hasNoGroupsProp = groupsOrDefault.length === 0;
    var isVisibleGroup = visibleGroups.includes(index);
    var isDefaultGroup = group === defaultRollupGroup;
    if (hasNoGroupsProp) {
      return hiddenActions.length > 0;
    }
    if (isDefaultGroup) {
      return true;
    }
    return isVisibleGroup;
  });
  var hiddenActionObjects = hiddenActions.map(function (index) {
    return actionsOrDefault[index];
  });
  var hiddenGroupObjects = hiddenGroups.map(function (index) {
    return groupsOrDefault[index];
  });
  var groupsMarkup = filteredGroups.map(function (group) {
    var title = group.title,
      groupActions = group.actions,
      rest = _objectWithoutProperties(group, _excluded2);
    var isDefaultGroup = group === defaultRollupGroup;
    var allHiddenItems = [].concat(_toConsumableArray(hiddenActionObjects), _toConsumableArray(hiddenGroupObjects));
    var _allHiddenItems$reduc = allHiddenItems.reduce(function (_ref2, action) {
        var _ref3 = _slicedToArray(_ref2, 2),
          actions = _ref3[0],
          sections = _ref3[1];
        if (isMenuGroup(action)) {
          sections.push({
            title: action.title,
            items: action.actions.map(function (sectionAction) {
              return _objectSpread(_objectSpread({}, sectionAction), {}, {
                disabled: action.disabled || sectionAction.disabled
              });
            })
          });
        } else {
          actions.push(action);
        }
        return [actions, sections];
      }, [[], []]),
      _allHiddenItems$reduc2 = _slicedToArray(_allHiddenItems$reduc, 2),
      finalRolledUpActions = _allHiddenItems$reduc2[0],
      finalRolledUpSectionGroups = _allHiddenItems$reduc2[1];
    if (!isDefaultGroup) {
      // Render a normal MenuGroup with just its actions
      return /*#__PURE__*/React.createElement(MenuGroup, Object.assign({
        key: title,
        title: title,
        active: title === activeMenuGroup,
        actions: groupActions
      }, rest, {
        onOpen: handleMenuGroupToggle,
        onClose: handleMenuGroupClose
      }));
    }
    return /*#__PURE__*/React.createElement(MenuGroup, Object.assign({
      key: title,
      title: title,
      active: title === activeMenuGroup,
      actions: [].concat(_toConsumableArray(finalRolledUpActions), _toConsumableArray(groupActions)),
      sections: finalRolledUpSectionGroups
    }, rest, {
      onOpen: handleMenuGroupToggle,
      onClose: handleMenuGroupClose
    }));
  });
  var handleMeasurement = useCallback(function (measurements) {
    var actionsWidths = measurements.hiddenActionsWidths,
      containerWidth = measurements.containerWidth,
      disclosureWidth = measurements.disclosureWidth;
    var _getVisibleAndHiddenA2 = getVisibleAndHiddenActionsIndices(actionsOrDefault, groupsOrDefault, disclosureWidth, actionsWidths, containerWidth),
      visibleActions = _getVisibleAndHiddenA2.visibleActions,
      hiddenActions = _getVisibleAndHiddenA2.hiddenActions,
      visibleGroups = _getVisibleAndHiddenA2.visibleGroups,
      hiddenGroups = _getVisibleAndHiddenA2.hiddenGroups;
    if (onActionRollup) {
      var isRollupActive = hiddenActions.length > 0 || hiddenGroups.length > 0;
      if (rollupActiveRef.current !== isRollupActive) {
        onActionRollup(isRollupActive);
        rollupActiveRef.current = isRollupActive;
      }
    }
    setState({
      visibleActions: visibleActions,
      hiddenActions: hiddenActions,
      visibleGroups: visibleGroups,
      hiddenGroups: hiddenGroups,
      actionsWidths: actionsWidths,
      containerWidth: containerWidth,
      disclosureWidth: disclosureWidth,
      hasMeasured: true
    });
  }, [actionsOrDefault, groupsOrDefault, onActionRollup]);
  var actionsMeasurer = /*#__PURE__*/React.createElement(ActionsMeasurer, {
    actions: actions,
    groups: groups,
    handleMeasurement: handleMeasurement
  });
  return /*#__PURE__*/React.createElement("div", {
    className: styles.ActionsLayoutOuter
  }, actionsMeasurer, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.ActionsLayout, !hasMeasured && styles['ActionsLayout--measuring'])
  }, actionsMarkup, groupsMarkup));
}
function isMenuGroup(actionOrMenuGroup) {
  return 'title' in actionOrMenuGroup;
}
export { Actions };